import './blocks/banner-slider/render-four.js';
import './blocks/banner-slider/render-three.js';
import './blocks/banner-slider/render-two.js';
import './blocks/banner-slider/render.js';
import './blocks/info-text-img/render.js';


